module.exports = __webpack_public_path__ + "img/icoChat.66a2a71.png";